import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import ResponsiveModal from "lib/ResponsiveModal";
import { useSelector } from "react-redux";
import { encryptUrl } from "api/UrlEncryption";

const ResponsiveDropdown = (props) => {
  const { label, custom_style, options, setisModalOpen ,selectedData} = props;
  const [toggle, setToggle] = useState(false);
  const [modal, setModal] = useState(true);
  const IndirectEval = (evalString) => {
    return eval(evalString);
  };

  const [selectedOption, setselectedOption] = useState();
  const { dashboardConfig } = useSelector((state) => state.dashboardReducer);
  const [encryptedListingID, setEncryptedID] = useState(null);
  const subwfLink = useSelector((state)=> state.dashboardDetailReducer?.dashboardDetailData?.subworkFlowInfo?.link)

  useEffect(() => {
      const fetchData = async () => {
          if (dashboardConfig) {
              const encryptedData =  await encryptUrl(dashboardConfig._id);
              setEncryptedID(encryptedData);
          } else {
              console.error("dashboardConfig is undefined");
          }
      };
      fetchData();
  }, [dashboardConfig]);
  

  const handleOptionClick = async (option) => {
    switch (option.type) {
      case "popup":
        setselectedOption(option);
        break;
      case "link":
        if (option.redirectToSamePage) {
          const encryptedID= await encryptUrl(option.bulk_config_id)
          window.location.href = `${option.routing_link}/${encryptedListingID}/${encryptedID}`; // Redirects in the same page
        }else if(option?.editWorkflow){
          window.open (subwfLink,'_blank')
        }
         else {
          window.open(option.routing_link, '_blank'); // Opens in a new tab
        }
        break;
      default:
        console.error(`optionType ${option.type} not found`);
    }
  };
  const closeModal = () => {
    setselectedOption(false);
  };

  return (
    <>
      {options &&options.length > 1 && options.some(option => IndirectEval(option?.show)) ? (
        <>
          <Dropdown onToggle={() => setToggle(!toggle)}>
            <Dropdown.Toggle
              className={`${custom_style} d-flex d-lg-block align-items-center justify-content-center w-100`}
              id="dropdown-basic"
            >  
              <span className="d-lg-none">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-plus-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                  />
                </svg>
              </span>
              <div className="d-flex align-items-center">
              <p className="mb-0 mt-1 fs-14px fw-bold d-none d-lg-block">
                {label}</p>
                <span className="border-1 h-20px border-end mx-2"></span>
              <span className={`delay-200ms mt-1 d-none d-lg-block`}>
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="13"
                  fill="currentColor"
                  className={`bi bi-caret-down-fill ${toggle ? "rotate-180deg" : ""}`}
                  viewBox="0 0 16 16"
                >
                  <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                </svg> */}

              <svg fill="currentColor" className={`${toggle ? "rotate-180deg" : ""}`} xmlns="http://www.w3.org/2000/svg" width="9.8" height="6.043" viewBox="0 0 9.8 6.043">
                <path id="expand_more_FILL0_wght400_GRAD0_opsz24_1_" data-name="expand_more_FILL0_wght400_GRAD0_opsz24 (1)" d="M244.9-634.957l-4.9-4.9L241.143-641l3.757,3.756L248.656-641l1.143,1.143Z" transform="translate(-240 641)"/>
              </svg>

              </span>
              </div>
             
            </Dropdown.Toggle>
            <Dropdown.Menu className="border-0 rounded-0 shadow-sm w-100 fs-14px" align={{xs:'start'}}>
              {options?.map((option, index) => {
                if (IndirectEval(option?.show)) {
                  return (
                    <Dropdown.Item
                      key={index}
                      onClick={() => handleOptionClick(option)}
                      className="bg-active-grey bg-hover-grey"
                    >
                      {option.label}
                    </Dropdown.Item>
                  );
                }
                return null; // Don't render if the condition is not satisfied
              })}
            </Dropdown.Menu>
          </Dropdown>
  
          {/* Mobile buttons */}
          <div className="d-flex d-none d-lg-none align-items-center h-100 justify-content-end justify-content-lg-evenly me-2">
            <Dropdown>
              <Dropdown.Toggle
                className="p-0 fs-25px d-flex border p-1 no-after mx-2"
                variant="white"
                id="dropdown-basic"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-plus-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu className="translate-middle-x border-0 shadow rounded-0">
                {options?.map((option, index) => {
                  if (IndirectEval(option?.show)) {
                    return (
                      <Dropdown.Item
                        key={index}
                        onClick={() => handleOptionClick(option)}
                        className="bg-active-grey bg-hover-grey"
                      >
                        {option.label}
                      </Dropdown.Item>
                    );
                  }
                  return null; // Don't render if the condition is not satisfied
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ) : (
        <>
          {options?.map((option, index) => {
            if (IndirectEval(option?.show)) {
              return (
                <button
                  key={index}
                  className={`btn ${custom_style}`}
                  onClick={() => handleOptionClick(option)}
                >
                  <span className="d-none d-lg-block mt-1">
                    {option.label}
                    <br />
                  </span>
                  <span className="d-lg-none">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
                </svg>
                  </span>
                </button>
              );
            }
            return null; // Don't render if the condition is not satisfied
          })}
        </>
      )}
  
      {modal && selectedOption && (
        <ResponsiveModal
          selectedOption={selectedOption}
          closeModal={closeModal}
        />
      )}
    </>
  );
};
export default ResponsiveDropdown;
